import React, { memo } from 'react';
import { ArrowForwardRounded, EmailRounded, GitHub, LinkedIn } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const Contact: React.FC = () => {
  const { i18n } = useTranslation();
  const isPt = i18n.language.startsWith('pt');

  const channels = [
    {
      label: 'LinkedIn',
      detail: isPt ? 'Conectar profissionalmente' : 'Connect professionally',
      href: 'https://www.linkedin.com/in/dev-angelo-castro/',
      icon: <LinkedIn />,
    },
    {
      label: 'GitHub',
      detail: isPt ? 'Explorar código e projetos' : 'Explore code and projects',
      href: 'https://github.com/AngeloCastro9',
      icon: <GitHub />,
    },
    {
      label: 'Email',
      detail: 'castroangelo1099@gmail.com',
      href: 'mailto:castroangelo1099@gmail.com',
      icon: <EmailRounded />,
    },
  ];

  return (
    <section id="contact" className="game-section">
      <div className="game-section__inner">
        <div className="game-contact-console">
          <div className="game-contact-console__intro">
            <span className="game-section__kicker">04 // {isPt ? 'CONTATO' : 'CONTACT'}</span>
            <h2>
              {isPt ? 'Vamos construir' : 'Let’s build'}
              <span>{isPt ? 'algo relevante.' : 'something meaningful.'}</span>
            </h2>
            <p>
              {isPt
                ? 'Se você procura liderança técnica, desenvolvimento full stack, arquitetura ou IA aplicada ao desenvolvimento, abra um canal e vamos conversar.'
                : 'If you are looking for technical leadership, full stack development, architecture, or AI applied to development, open a channel and let’s talk.'}
            </p>
          </div>

          <div className="game-contact-console__links">
            <span className="game-contact-console__links-label">{isPt ? 'CANAIS DE CONTATO' : 'CONTACT CHANNELS'}</span>
            {channels.map((channel) => (
              <a
                className="game-contact-link"
                href={channel.href}
                target={channel.href.startsWith('http') ? '_blank' : undefined}
                rel={channel.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                key={channel.label}
              >
                <span className="game-contact-link__icon">{channel.icon}</span>
                <span>
                  <strong>{channel.label}</strong>
                  <small>{channel.detail}</small>
                </span>
                <ArrowForwardRounded fontSize="small" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(Contact);
